import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import { useAuthStore } from '@/store/auth'
import { setUnauthorizedHandler } from '@/api/axios'
import 'bootstrap/dist/css/bootstrap.min.css'
import './css/style.css'
import 'bootstrap'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

const auth = useAuthStore(pinia)

setUnauthorizedHandler(() => {
  if (!auth.isAuthenticated) {
    return
  }

  auth.logout()
  const currentPath = router.currentRoute.value?.fullPath || '/'
  if (router.currentRoute.value?.name !== 'Login') {
    router.push({ name: 'Login', query: { redirect: currentPath } })
  }
})

app.mount('#app')
